// extracted by css-extract-rspack-plugin
export default {"cls1":"server_side_bulk_downloader-cls1_07X","cls2":"server_side_bulk_downloader-cls2_Pc_ server_side_bulk_downloader-cls1_07X"};